import React from 'react'
import { apiFetch } from '../../../../fetchApi'

export const deleteProjects = ({ BeURL, id, showAlert, setProjects, handleTopClear, candidateId }) => {
    apiFetch(`${BeURL}/candidate-projects-delete/${id}/${candidateId}`, {
        method: "DELETE",
        credentials: 'include'
    })
        .then(res => res.json())
        .then(data => {
            if (data.success) {
                showAlert(data.message)
                setProjects(data.projects)
                handleTopClear()
            }
            else {
                alert(data.message)
            }
        })
        .catch(err => {
            console.log("Error to Delete candidate projects", err)
        })
}
